import React, { useEffect, useState } from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import { useAuth } from "../../../contexts/AuthContext";
import { getSuscripciones } from "../../../services/wordpress/micuenta";
import { Pill } from "../Pill";

const formatearFecha = (fecha) => {
  if (!fecha) return "-";
  const d = new Date(fecha);
  return isNaN(d.getTime()) ? fecha : d.toLocaleDateString("es-ES");
};

const estadoTono = (estado) => {
  if (estado === "active") return "active";
  if (estado === "on-hold" || estado === "pending") return "pending";
  if (estado === "cancelled" || estado === "expired") return "danger";
  return undefined;
};

export const Suscripciones = () => {
  const { mode } = useTheme() || { mode: "light" };
  const isDark = mode === "dark";
  const auth = useAuth();

  const [suscripciones, setSuscripciones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState(null);

  const textPrimary = isDark ? "#f1f5f9" : "#1e293b";
  const textSecondary = isDark ? "#94a3b8" : "#64748b";
  const borderColor = isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0";

  useEffect(() => {
    if (!auth.apiToken || !auth.wpUrl) {
      setCargando(false);
      return;
    }
    let cancelado = false;
    getSuscripciones({ wpUrl: auth.wpUrl, apiToken: auth.apiToken })
      .then((data) => {
        if (!cancelado) setSuscripciones(data);
      })
      .catch(() => {
        if (!cancelado) setError("No se pudieron cargar las suscripciones.");
      })
      .finally(() => {
        if (!cancelado) setCargando(false);
      });
    return () => {
      cancelado = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.apiToken, auth.wpUrl]);

  if (cargando && suscripciones.length === 0) {
    return <p style={{ fontSize: 13, color: textSecondary, margin: 0 }}>Cargando...</p>;
  }

  if (suscripciones.length === 0) {
    return (
      <p style={{ fontSize: 13, color: textSecondary, fontStyle: "italic", margin: 0 }}>
        {error || "No tienes suscripciones activas."}
      </p>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {suscripciones.map((s) => (
        <div
          key={s.id}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
            flexWrap: "wrap",
            borderRadius: 16,
            border: `1px solid ${borderColor}`,
            padding: "16px 20px",
          }}
        >
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
              <span style={{ fontSize: 15, fontWeight: 700, color: textPrimary }}>{s.producto}</span>
              <Pill tone={estadoTono(s.estado)}>{s.estado}</Pill>
            </div>
            <span style={{ fontSize: 12, color: textSecondary }}>
              Desde {formatearFecha(s.inicio)}
            </span>
          </div>

          <div style={{ textAlign: "right" }}>
            <span style={{ display: "block", fontSize: 11, color: textSecondary, textTransform: "uppercase", letterSpacing: "0.05em" }}>
              Próximo pago
            </span>
            <span style={{ fontSize: 14, fontWeight: 600, color: textPrimary }}>
              {formatearFecha(s.proximo_pago)}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};
